export default __webpack_public_path__ + "static/media/Print Deposit Slip_Dark2.3010bc03.svg";